// ── SugeTek POS Design System palette ────────────────────────────────────────
// Source of truth: pos-flutter/lib/app/theme/app_color.dart (AppColorExtension)
//
// IMPORTANT: the KEYS are unchanged from the previous (blue) theme, so every
// existing `text-dark-900`, `bg-dark-20`, `color="primary"` etc. keeps working —
// only the values are remapped onto the design-system ramp. This is what makes
// the re-skin a low-risk, mostly-mechanical change.
//
//   old blue theme            →  DS token
//   primary   #3587dc         →  --color-brand        #e55e0b
//   primary-50 #EBF3FC        →  --color-brand-bg     #fff6e8
//   sidebar   #373d4f         →  --color-surface(dark) #21201e
//   dark-20   #f6f6f7         →  --color-surface      #f7f6f5
//   dark-40   #e0e1e4         →  --color-stroke-light #ebeae8
//   dark-900  #131c2d         →  --color-primary      #21201e

export const colors = {
  // Brand — the single "act now" accent. Used for primary buttons, active nav,
  // selection outlines. Nothing decorative.
  primary: '#e55e0b',
  'primary-50': '#fff6e8', // brand wash — selected rows, active tiles
  'primary-100': '#f0a46b', // brand mid tint — charts, hover fills

  // Semantic accents (DS foreground values)
  warning: '#eda005',
  success: '#2da465',
  error: '#d92238',
  info: '#4a89dd',

  // Semantic accent washes — new keys, for badges/pills (bg-success-bg etc.)
  'warning-bg': '#fff7d9',
  'success-bg': '#e9fbef',
  'error-bg': '#feeaea',
  'info-bg': '#edf4ff',

  background: '#ffffff',
  surface: '#ffffff',
  // Explicit on-* so Vuetify field/label text uses DS primary, not a washed
  // auto-contrast gray against the white field fill.
  'on-background': '#21201e',
  'on-surface': '#21201e',

  // Sidebar — DS dark theme surface (the same charcoal as the POS sign-in screen)
  sidebar: '#21201e',
  'on-sidebar': '#ffffff',

  'muted-text': '#75736f', // --color-secondary

  // Warm neutral ramp — replaces the old cool grays 1:1
  'dark-10': '#fafaf9',
  'dark-20': '#f7f6f5', // --color-surface (app canvas)
  'dark-30': '#f2f1f0', // --color-on-background (neutral fill)
  'dark-40': '#ebeae8', // --color-stroke-light
  'dark-50': '#dbdad7', // --color-stroke-bold
  'dark-100': '#b3b0ac', // --color-tertiary
  'dark-500': '#75736f', // --color-secondary
  'dark-900': '#21201e', // --color-primary
};

export const componentDefaults = {
  VSelect: {
    density: 'compact',
  },
  VTextField: {
    density: 'compact',
  },
  VTextarea: {
    density: 'compact',
  },
  VAutocomplete: {
    density: 'compact',
  },
  VCombobox: {
    density: 'compact',
  },
  VRow: {
    noGutters: true,
  },
};
